import React, { useState } from 'react';
import { useTheme } from '../context/ThemeContext';
import { useAuth } from '../context/AuthContext';
import { Link, useNavigate } from 'react-router-dom';
import './Login.css';

const Login = () => {
    const { isDarkTheme } = useTheme();
    const { signIn, user, loading } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    // Redirect if already logged in
    React.useEffect(() => {
        if (!loading && user) {
            navigate('/units', { replace: true });
        }
    }, [user, loading, navigate]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError('');
        setIsLoading(true);

        try {
            await signIn({ email, password });
            setTimeout(() => {
                navigate('/units');
            }, 100);
        } catch (err) {
            setError(err.message || 'Unable to sign in. Please check your credentials and try again.');
            setIsLoading(false);
        }
    };

    return (
        <div className={`login-container ${isDarkTheme ? 'dark' : 'light'}`}>
            <div className="login-card">
                <div className="login-header">
                    <h2>Welcome Back</h2>
                    <p className="login-subtitle">Sign in to continue your learning journey.</p>
                </div>

                {error && <div className="error-message">{error}</div>}

                <form className="login-form" onSubmit={handleSubmit}>
                    <div className="input-group">
                        <label htmlFor="email">Email</label>
                        <input
                            id="email"
                            type="email"
                            value={email}
                            onChange={(event) => setEmail(event.target.value)}
                            placeholder="you@example.com"
                            required
                        />
                    </div>
                    <div className="input-group">
                        <label htmlFor="password">Password</label>
                        <input
                            id="password"
                            type="password"
                            value={password}
                            onChange={(event) => setPassword(event.target.value)}
                            placeholder="••••••••"
                            required
                        />
                    </div>
                    <button type="submit" className="login-button" disabled={isLoading}>
                        {isLoading ? 'Signing in...' : 'Sign In'}
                    </button>
                </form>

                <div className="signup-option">
                    <span>New to MathBox?</span>
                    <Link to="/signup" className="toggle-signup">Create an account</Link>
                </div>
            </div>
        </div>
    );
};

export default Login;